import { HStack, Icon, Stack, Tooltip } from "@chakra-ui/react";
import CDS from "design-system";

import { FIELD_TYPE_ICON, FIELD_TYPE_LABEL, FIELD_TYPES_IN_PALETTE_ORDER } from "../../constants";
import type { CustomFormFieldType } from "../../types";

interface Props {
  onAdd: (type: CustomFormFieldType) => void;
  compact?: boolean;
}

export default function FieldPalette({ onAdd, compact = false }: Props) {
  return (
    <Stack spacing={1} w={compact ? "56px" : "200px"} flexShrink={0}>
      {!compact && (
        <CDS.Text12
          color="content.tertiary"
          fontWeight="bold"
          textTransform="uppercase"
          letterSpacing="wide"
          px={2}
          pb={1}
        >
          Add field
        </CDS.Text12>
      )}
      {FIELD_TYPES_IN_PALETTE_ORDER.map((type) => (
        <Tooltip
          key={type}
          label={compact ? FIELD_TYPE_LABEL[type] : ""}
          placement="right"
          isDisabled={!compact}
          hasArrow
        >
          <HStack
            as="button"
            type="button"
            spacing={2}
            px={2}
            h="36px"
            w="100%"
            borderRadius="base"
            cursor="pointer"
            color="content.secondary"
            _hover={{ bg: "bg.tertiary", color: "content.primary" }}
            onClick={() => onAdd(type)}
          >
            <Icon as={FIELD_TYPE_ICON[type]} boxSize={4} color="content.tertiary" />
            {!compact && (
              <CDS.Text14 color="content.secondary">{FIELD_TYPE_LABEL[type]}</CDS.Text14>
            )}
          </HStack>
        </Tooltip>
      ))}
    </Stack>
  );
}
